import React, { PureComponent } from 'react';

class TarjetaHeader extends PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        const classAcordeon = `row no-margin box header gris cc-acordeon ${this.props.toggleClass}`;
        const { data } = this.props;
        let component = null;

        return (
            <div className={classAcordeon} onClick={() => this.props.onToggleAcordeon(this.props.index)}>
                <div className="col-xs-5 text-left">
                    <label className="label-secondary">{this.props.data.NombreApellido}</label>
                </div>
                <div className="col-xs-6 text-left">
                    <label className="label-secondary">{this.props.data.TarjetaCreditoNumero}</label>
                </div>
                <div className="col-xs-1 text-left">
                    <span className={"ti ti-angle-" + ((this.props.toggleClass == "") ? "down" : "up")}></span>
                </div>
            </div>
        )

    }
}

export default TarjetaHeader;